<template>
  <div class="page_container" @click="emitAppClicked">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">

    <div class="main_page_container">
      <Header v-if="$route.path !== '/awdoc'" class="header"/>

      <MainContent class="content"/>
    </div>

    <Footer v-if="$route.path !== '/awdoc'" class="footer"/>

    <b-modal ref="mainErrorMessageModal" id="mainErrorMessageModal" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close
             @hide="checkCloseCloseMessageModal">
      <b-container>
        <h5> {{message}}!</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-ok-error-message" class="m-1 b-c-green" @click="hideMainErrorMessageModal('close')">Ok</b-button>
      </div>
    </b-modal>

    <b-modal ref="deleteModal" id="deleteModal" :title="`${$t('message.caution')}!`">
      <b-container>
        <h5>{{$t('message.deleteCheck')}} {{deleteItem.description}}?</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-delete-close" class="m-1 b-c-green" @click="hideDeleteModal()">{{$t('message.cancel')}}</b-button>

        <b-button id="nw-delete-continue" class="m-1 b-c-green" @click="deleteContinue(deleteItem.path)">{{$t('message.continue')}}</b-button>
      </div>
    </b-modal>

    <b-modal ref="infoModal" id="infoModal" :title="`${$t('message.info')}`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{infoMessage}}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green" @click="$refs.infoModal.hide()"> Ok </b-button>
      </div>
    </b-modal>

    <b-modal ref="goBackModal" id="goBackModal" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{$tc('warnings.notSavedTabChanges', 1)}}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green mr-3" id="ok-back-modal" @click="pushBack(goBackObj)"> {{$tc('message.continue', 1)}} </b-button>

        <b-button class="b-c-green" id="close-back-modal" @click="$refs.goBackModal.hide()"> {{$tc('message.close', 1)}} </b-button>
      </div>
    </b-modal>

    <!-- Loader -->
    <div class="loader-opacity" v-if="loaderActive"></div>
    <div class="loader-container" v-if="loaderActive">
      <moon-loader :color="'#249a80'"/>
      <div class="loader-label mt-2"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Header from './fragments/Header'
import MainContent from './fragments/MainContent'
import Footer from './fragments/Footer'
import { MoonLoader } from 'vue-spinner/dist/vue-spinner'

export default {
  components: {
    Footer,
    MainContent,
    Header,
    MoonLoader
  },
  name: 'app',
  props: ['idle'],
  watch: {
    idle (isIdle) {
      const tabs = Vue.getLocalStorage('tabs')
      let inactive = Vue.getLocalStorage('inactive')
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const readExpulsionMessage = Vue.getLocalStorage('readExpulsionMessage')
      const isExpelled = Vue.getLocalStorage('isExpelled')
      const message = this.$t('message.sessionExpired')
      if (isIdle) {
        inactive += 1
        Vue.setLocalStorage('inactive', inactive)
      }
      if (!isIdle) {
        if (inactive && inactive >= 1) {
          inactive -= 1
          Vue.setLocalStorage('inactive', inactive)
        } else if (inactive && inactive < 1) {
          Vue.setLocalStorage('inactive', 0)
        }
      }
      if (isIdle && token && tabs && inactive && tabs === inactive) {
        this.$root.$emit('sessionExpired', message)
      }
      if (isExpelled && !token && readExpulsionMessage) {
        this.hideMainErrorMessageModal('close')
      } else if (isExpelled && !token && !readExpulsionMessage) {
        this.$root.$emit('sessionExpired', message)
      }
    }
  },
  data () {
    return {
      message: '',
      constraint: '',
      objName: '',
      route: {},
      deleteItem: {},
      logObjDeletedItem: {},
      modalObj: {
        modalItSelf: '',
        modalBeforeItSelf: ''
      },
      disableExcel: false,
      loaderActive: false,
      infoMessage: '',
      size: null,
      isMobile: null,
      goBackObj: {}
    }
  },
  beforeMount () {
    this.checkDevice()
  },
  mounted () {
    this.$root.$on('sessionExpired', (message) => {
      const refs = this.$refs
      if (refs && refs.mainErrorMessageModal) {
        refs.mainErrorMessageModal.show()
        this.message = ''
        this.message = message
      }
      Vue.deleteLocalStorage('readExpulsionMessage')
      Vue.deleteLocalStorage('session')
      Vue.deleteLocalStorage('routes')
      Vue.setLocalStorage('isExpelled', true)
      this.$router.push('/')
    })
    this.$root.$on('mustBeDisconnected', (message) => {
      Vue.error(this, message)
      this.logout()
    })
    this.$root.$on('showErrorMessage', (obj) => {
      const message = obj && obj.message
      const mustBeExpelled = obj && obj.mustBeExpelled
      const refs = this.$refs
      if (refs && refs.mainErrorMessageModal) {
        refs.mainErrorMessageModal.show()
        this.message = ''
        this.message = message
      }
      if (mustBeExpelled) {
        Vue.deleteLocalStorage('session')
        Vue.deleteLocalStorage('routes')
        Vue.setLocalStorage('isExpelled', true)
        this.$router.push('/')
      }
    })
    this.$root.$on('deleteItem', (obj, logObj) => {
      this.deleteItem = obj
      this.logObjDeletedItem = logObj
      if (this.$refs && this.$refs.deleteModal) {
        this.$refs.deleteModal.show()
      }
    })
    this.$root.$on('activeLoader', (active) => {
      this.loaderActive = active
    })
    this.$root.$on('info-modal', (infoMessage) => {
      this.infoMessage = infoMessage
      if (this.$refs.infoModal) {
        this.$refs.infoModal.show()
      }
    })
    this.$root.$on('go-back-modal', obj => {
      this.goBackObj = obj
      if (this.$refs.goBackModal) {
        this.$refs.goBackModal.show()
      }
    })

    this.$nextTick(() => {
      window.onresize = () => {
        this.checkSize()
      }
      window.onfocus = () => {
        const session = Vue.getLocalStorage('session')
        const token = session && session.token
        const readExpulsionMessage = Vue.getLocalStorage('readExpulsionMessage')
        const isExpelled = Vue.getLocalStorage('isExpelled')
        if (isExpelled && !token && readExpulsionMessage) {
          this.hideMainErrorMessageModal('close')
        } else if (isExpelled && !token && !readExpulsionMessage) {
          const message = 'La sessione risulta inattiva da più di 15 minuti, eseguire nuovamente l\'accesso'
          this.$root.$emit('sessionExpired', message)
        }
      }
    })

    this.checkSize()
  },
  beforeDestroy () {
    window.onresize = null
    window.onfocus = null
  },
  methods: {
    checkDevice () {
      if (navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i)) {
        this.disableExcel = true
      } else if (navigator &&
        navigator.userAgent &&
        !navigator.userAgent.match(/iPhone/i) &&
        !navigator.userAgent.match(/iPad/i) &&
        !navigator.userAgent.match(/iPod/i)) {
        this.disableExcel = false
      }
      this.checkExcel()
    },
    checkExcel () {
      /* eslint-disable no-param-reassign */
      const excelButton = document.getElementById('excel-button')
      if (this.disableExcel && excelButton) {
        excelButton.style.display = 'none'
      } else if (excelButton) {
        excelButton.style.display = 'block'
      }
    },
    hideMainErrorMessageModal (exception) {
      const isExpelled = Vue.getLocalStorage('isExpelled')
      if (isExpelled) {
        Vue.deleteLocalStorage('readExpulsionMessage')
        Vue.setLocalStorage('readExpulsionMessage', true)
      }
      if (exception === 'close') {
        this.$refs.mainErrorMessageModal.hide('button')
        this.message = ''
        this.constraint = ''
        this.objName = ''
      } else if (exception.cancelable) {
        exception.preventDefault()
      }
    },
    checkCloseCloseMessageModal (obj) {
      if (obj.trigger !== 'button') {
        obj.preventDefault()
      }
    },
    deleteContinue (path) {
      Vue.myDelete(this, path, this.logObjDeletedItem).then(() => {
        Vue.success(this, `${this.$tc('message.delete')} ${this.$tc('message.done', 2).toLowerCase()}`)
        const deleteParams = this.deleteItem
        if (deleteParams) this.$router.push({ name: 'RefreshPage', params: deleteParams })
        this.hideDeleteModal()
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
      })
    },
    hideDeleteModal () {
      this.$refs.deleteModal.hide()
      this.deleteItem = {}
    },
    emitAppClicked () {
      if (this && this.$root) this.$root.$emit('app-clicked')
    },
    logout () {
      Vue.deleteLocalStorage('session')
      Vue.deleteLocalStorage('routes')
      this.$router.push('/')
    },
    checkSize () {
      const size = Vue.myGetWindowSize()
      if (this.size !== size) {
        this.size = size
        this.isMobile = size !== 'lg' && size !== 'xl'
        this.$root.$emit('resize', size)
      }
    },
    pushBack (backObj) {
      this.$router.push(backObj)
      this.$refs.goBackModal.hide()
    }
  }
}
</script>

<style>
  /* main components */
  html, body {
    height: 100%;
  }
  .leaflet-container {
    height: 100%;
    width: 100%;
    position:sticky !important;
    z-index: 0 !important;
  }
  .leaflet-popup-close-button {
    margin-right: 10px !important;
    margin-top: 10px !important;
    font-size: 22px !important;
  }
  .page_container{
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .header {
    background-color: #fafafa;
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
  }
  .content {
    display: flex;
    flex: 1 1 auto;
  }
  .footer {
    background-color: #343a40;
    color: azure;
  }
  .main_page_container {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    width: 100%;
    max-width: 100%;
  }
  .show {
    align-items: center;
    display: flex;
  }
  .modal-dialog {
    width: 100%;
  }
  .lang-it > label::after {
    background-color: #249a80;
    color: white;
    content: "Cerca";
  }
  .lang-en label::after {
    background-color: #249a80;
    color: white;
    content: "Browse";
  }
  .my-label {
    font-variant: small-caps;
    font-size: 14px
  }

  .br-tr {
    border-top-right-radius: 0.25rem !important;
  }

  .br-br {
    border-bottom-right-radius: 0.25rem !important;
  }

  .br-tl {
    border-top-left-radius: 0.25rem !important;
  }

  .br-bl {
    border-bottom-left-radius: 0.25rem !important;
  }

  .v-sidebar-menu {
    height: auto !important;
    display: flex;
    flex-direction: column-reverse !important;
  }
  .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1,
  .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon,
  .vsm--icon {
    background-color: #249a80 !important;
  }
  .v-sidebar-menu .vsm--mobile-bg, .vsm--link_level-1:hover .vsm--icon, .vsm--icon:hover {
    background-color: #249a80 !important;
  }
  .v-sidebar-menu .vsm--link_level-1.vsm--link_active {
    overflow: hidden !important;
  }

  .v-sidebar-menu .vsm--header {
    text-transform: none !important;
    font-size: 22px !important;
  }
  .vsm--link_active {
    font-weight: 200 !important;
  }

  .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active, .v-sidebar-menu .vsm--link_level-1.vsm--link_active {
    -webkit-box-shadow: 3px 0 0 0 #007a79 inset !important;
    box-shadow: 3px 0 0 0 #007a79 inset !important;
    overflow: auto;
  }
  .collapse-btn {
    order: 1 !important;
    position: relative !important;
  }
  .vsm-list, .vsm--list {
    order: 2 !important;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  }
  .collapse-btn:after {
    content: "\f0c9" !important;
  }
  .vsm-collapsed > div:nth-child(2) {
    width: 250px !important;
  }
  .vsm-dropdown {
    overflow-x: hidden !important;
    max-height: calc(16px + 7 * ((60vw - 70px) / 10)) !important
  }
  .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1,
  .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon {
    background-color: #249a80 !important;
  }
  .v-sidebar-menu .vsm--mobile-bg, .vsm--link_level-1:hover .vsm--icon, .vsm--icon:hover  {
    background-color: #249a80 !important;
  }

  .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active, .v-sidebar-menu .vsm--link_level-1.vsm--link_active {
    -webkit-box-shadow: 3px 0 0 0 #007a79 inset !important;
    box-shadow: 3px 0 0 0 #007a79 inset !important;
  }

  /* Main colors */
  .b-c-green {
    background-color: #249a80 !important;
  }
  .c-green {
    color: #249a80 !important;
  }
  .border-c-green {
    border-color: #249a80 !important;
  }
  .h-c-green:hover {
    color: #249a80;
  }
  .c-green-opacity {
    background-color: rgba(36, 154, 128, 0.8) !important;
  }

  .b-c-yellow {
    background-color: rgba(245, 245, 0, 0.8) !important;
  }
  .c-yellow {
    color: rgba(245, 245, 0, 0.8) !important;
  }
  .border-c-yellow {
    border-color: rgba(245, 245, 0, 0.8) !important;
  }
  .h-c-yellow:hover {
    color: rgba(245, 245, 0, 0.8);
  }
  .c-yellow-opacity {
    background-color: rgba(245, 245, 0, 0.6) !important;
  }

  .b-c-red {
    background-color: #dc3545 !important;
  }
  .c-red {
    color: #dc3545 !important;
  }

  .b-c-blue {
    background-color: #4285f4 !important;
  }
  .c-blue {
    color: #4285f4 !important;
  }
  .h-b-c-blue:hover {
    background-color: #4285f4 !important;
  }
  .h-c-blue:hover {
    color: #4285f4 !important;
  }

  .b-c-black {
    background-color: #1e1e21;
  }
  .c-black {
    color: #1e1e21;
  }
  .h-b-c-black:hover {
    background-color: #1e1e21;
  }
  .c-gray {
    color: #2a2a2e;
  }
  .b-c-gray {
    background-color: #2a2a2e;
  }
  .c-m-gray {
    color: #36363b;
  }
  .b-c-m-gray {
    background-color: #36363b;
  }
  .c-ls-gray {
    color: lightslategray;
  }
  .b-c-ls-gray {
    background-color: lightslategray;
  }
  .c-l-gray {
    color: #adb5bd;
  }
  .b-c-l-gray {
    background-color: #adb5bd;
  }
  .c-s-white {
    color: #e6e6e6;
  }
  .b-c-s-white {
    background-color: #e6e6e6;
  }
  .c-white {
    color: white !important;
  }

  /* Plugin components */
  .breadcrumb {
    margin-bottom: 0 !important;
  }
  .collapse-btn {
    order: 1 !important;
    position: relative !important;
  }
  .vsm-list {
    order: 2 !important;
  }
  .collapse-btn:after {
    content: "\f0c9" !important;
  }
  .vsm-collapsed > div:nth-child(2) {
    width: 250px !important;
  }
  .vsm-dropdown {
    overflow-x: hidden !important;
    max-height: calc(16px + 7 * ((60vw - 70px) / 10)) !important
  }

  .custom-file-label::after {
    font-family: "Font Awesome 5 Free",serif; font-weight: 900; content: "\f002" !important;
  }

  .loader-opacity {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1100;
    opacity: .75;
    background-color: black;
  }

  .loader-container {
    position: fixed;
    display: flex;
    flex-direction: column;
    z-index: 1150;
    overflow: hidden;
    outline: 0;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  .loader-label {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    text-align: center;
    font-size: calc(20px + 6 * ((100vw - 150px) / 500)) !important;
    color: #249a80;
    font-family: 'ArchitectsDaughter',serif;
  }

  /* Table style */
  .first-table-cols > th:nth-child(1),
  .first-2-table-cols > th:nth-child(1),
  .first-2-table-cols > th:nth-child(2),
  .first-3-table-cols > th:nth-child(1),
  .first-3-table-cols > th:nth-child(2),
  .first-3-table-cols > th:nth-child(3) {
    width: 60px !important;
  }

  .first-table-cols > th:nth-child(10) {
    width: 10rem !important;
  }
  .stackedStyle > tbody > tr {
    border-top: 1px solid #dee2e6;
    font-size: 14px;
  }
  .stackedStyle > tbody > tr > td {
    padding: 3px;
    border-top: 0;
  }
  .stackedStyle > tbody > tr > td > div {
    overflow: auto;
  }
  .stackedStyleCols > tbody > tr > [data-label] > div {
    max-width: 50vw !important;
  }
  .stackedStyle > tbody > tr > td > div > button {
    line-height: 15px;
    padding: 5px;
    margin: 0 5px 0 0;
    float: right;
  }
  .stackedStyle > tbody > tr > td > div > div > .custom-control-label::before,
  .stackedStyle > tbody > tr > td > div > div > .custom-control-label::after,
  .stackedStyle > .custom-control-label:after,
  .stackedStyle > .custom-control-label:before {
    width: 27px;
    height: 27px;
    top: 0;
  }
  .notStackedStyle > tbody > tr > .flexible-row > div {
    display: block !important;
  }
  .page-item.active .page-link {
    background-color: #249a80 !important;
    border-color: #249a80 !important;
  }
  .page-link, .vsm-link {
    color: #212529 !important;
  }
  .page-item.active > button {
    color: white !important;
  }
  /* main style */
  .mw-100 {
    max-width: 100% !important;
  }
  .custom-control-input:checked~.custom-control-label::before {
    border-color: #249a80 !important;
    background-color: #249a80 !important;
  }
  .nav-link, a {
    color: #249a80;
  }
  .flatpickr-day.selected {
    background-color: #249a80 !important;
  }
  .nav-pills .nav-link.active, .nav-pills .show>.nav-link{
    color: white !important;
    background-color: #249a80 !important;
  }
  .leaflet-container a {
    color: #249a80 !important;
  }
  .form-control[disabled='tue'] {
    background-color: #6c757d !important;
    cursor: not-allowed;
  }
  .form-control[disabled='false'] {
    background-color: white !important;
  }
  .nav-link:hover, a:hover {
    color: rgba(36, 154, 128, 0.5);
  }
  .breadcrumb-item > a[href='#'] {
    color: #6c757d !important;
    text-decoration: none;
  }
  .breadcrumb-item > a {
    color: #249a80 !important;
    text-decoration: none;
  }
  .breadcrumb-item > a[href='#']:hover, .breadcrumb-item > span {
    cursor: not-allowed;
  }
  .flexible-row {
    display: flex !important;
  }
  .flexible-row::before {
    display: none !important;
  }
  .flexible-row > div {
    display: flex !important;
    width: 100%;
  }
  .hover-enabled, .vue-slider {
    cursor: pointer;
  }
  .hover-not-allowed {
    cursor: not-allowed;
  }
  .underline:hover {
    text-decoration: underline !important;
  }
  .dropdown-menu {
    min-width: 0 !important;
  }
  .tinyCard {
    display: flex;
    justify-content: center;
    max-width: 700px;
    margin: auto;
  }
  .tiny-label {
    margin: 0;
    font-size: medium;
  }
  .tab-content {

  }

  .leaflet-popup-content{
    margin: 10px;
  }
  .form-control[readonly] {
    background-color: white !important;
  }
  .form-control:disabled {
    background-color: #e9ecef !important;
    cursor: not-allowed;
  }
  .ellipse > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .disabled {
    cursor: not-allowed !important;
  }

  .my-invalid-feedback {
    width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #dc3545;
  }

  .form-control::-webkit-input-placeholder { color: lightgray !important; }  /* WebKit, Blink, Edge */
  .form-control:-moz-placeholder { color: lightgray !important; }  /* Mozilla Firefox 4 to 18 */
  .form-control::-moz-placeholder { color: lightgray !important; }  /* Mozilla Firefox 19+ */
  .form-control:-ms-input-placeholder { color: lightgray !important; }  /* Internet Explorer 10-11 */
  .form-control::-ms-input-placeholder { color: lightgray !important; }

  /* TODO check Sidebar Items */
  .vsm-link[href='#/assignment_obu'],
  .vsm-link[href='#/assignment_key'],
  .vsm-link[href='#/assignment_vehicle'],
  .vsm-link[href='#/registry_person'],
  .vsm-link[href='#/attachment'],
  .vsm-link[href='#/operation_management'],
  .vsm-link[href='#/rental'],
  .vsm-link[href='#/service'],
  .vsm-link[href='#/accident'] {
    color: gray !important;
  }

  .vsm--scroll-wrapper{
    margin-right: 0 !important;
  }
  .penalty-icon {
    padding: 5px;
  }
</style>
